import "./RentIdPage.css";
import RentidPC from "../components/rentid-landing";

const RentIdPage = () => {
  return <RentidPC />;
};

export default RentIdPage;
